import { useQuery } from '@apollo/client';
import { ALL_MODULES, AsyncPropSelector, T1 } from '@nile/components';
import { GET_ALL_TECHS_NEW } from '@nile/graphql';
import { AccountClient } from '@nile/graphql';
import { DisabledTag } from '@nile/mangifera/src/Pebbles/TicketContainer';
import {
  DropdownIndicator,
  formatGroupLabel,
  formatOptionLabel,
  IndicatorSeparator,
  isAuthorised,
  AppContext
} from '@nile/components';
import { Edit } from '@styled-icons/material/Edit';
import { Popover, Button, ButtonGroup } from '@superops/ui-design-system';
import { cloneDeep } from 'lodash';
import Select from 'react-select';
import React, { useCallback, useState, useContext } from 'react';
import styled from 'styled-components';
import { EditIcon } from '@nile/components/src/Icons';

const CustomField = styled.div`
  min-width: 200px;
  max-width: 250px;
  flex-grow: 1;
  padding-right: 10px;
  padding-left: 10px;
  margin-top: 8px;
  margin-bottom: 8px;
  .Polaris-ButtonGroup {
    margin-top: 12px;
  }
`;

const Label = styled.div`
  text-align: left;
  margin-left: 10px;
  margin-top: 10px;
`;

const Wrap = styled.div`
  display: flex;
  align-items: center;
  .edit-actions {
    visibility: hidden;
    cursor: pointer;
  }
  padding-left: 8px;
  padding-right: 8px;
  max-width: 100%;
`;

const CField = styled.div`
  .editable-cell,
  .cell {
    flex-grow: 1;
    font-weight: bold;
  }
  &:hover {
    .edit-actions {
      visibility: visible;
    }
  }
`;

function MultiSelectTextCell(props) {
  const {
    field,
    _ticket,
    defaultValue,
    updateSelection,
    inlineEdit,
    isMulti,
    params
  } = props;
  const { editable, parentField, dependantField, actions, accessor } = params;
  const appContext = useContext(AppContext);
  const currentUser = appContext?.user || {};
  const userRole = currentUser?.role?.roleFeatureList || [];
  const isTechAuthorised = isAuthorised(userRole, 'employees.view');

  const ticket = _ticket;
  const value = defaultValue;
  const [options, setOptions] = useState([]);
  const { loading, data: technicians } = useQuery(GET_ALL_TECHS_NEW, {
    client: AccountClient,
    skip: !isTechAuthorised,
    variables: {
      input: {
        listInfo: {
          sort: {
            attribute: 'name',
            order: 'ASC'
          }
        }
      }
    },
    onCompleted({ getTechnicianList }) {
      if (getTechnicianList) {
        const customOptions = getTechnicianList.userList.map((el) => {
          return {
            ...el,
            name: el.userId,
            value: el.name,
            label: el.name
          };
        });
        setOptions(customOptions);
      }
    }
  });

  const updateSelectedField = (val) => {
    if (!val) {
      updateSelection(field, []);
    }
    updateSelection(field, val);
  };
  const [popoverActive, setPopoverActive] = useState(false);
  const togglePopoverActive = useCallback(() => {
    setPopoverActive(!popoverActive);
  });
  const [updatedValue, setUpdatedValue] = useState(value);
  const updateUpdatedValue = (val) => {
    if (!val) {
      setUpdatedValue([]);
    }
    setUpdatedValue(val);
  };
  if (loading) return <div>loading...</div>;
  const displayVal = value ? value.map((el) => el.name).join(', ') : '';

  const activator = <EditIcon onClick={() => togglePopoverActive()} />;
  const getTag = () => {
    return (
      <CustomField>
        <Label>{field.label || ''}</Label>
        <div className="flex col" key={field.name}>
          <Select
            className="propSelector"
            key={defaultValue}
            classNamePrefix="value_selector"
            formatGroupLabel={formatGroupLabel}
            formatOptionLabel={formatOptionLabel}
            defaultValue={updatedValue}
            components={{ IndicatorSeparator, DropdownIndicator }}
            onChange={updateUpdatedValue}
            options={options}
            placeholder="Choose value"
            menuPortalTarget={document.body}
            menuPlacement="auto"
            closeMenuOnScroll={(e) => {
              e.stopPropagation();
              e.preventDefault();
              return (
                e.target &&
                e.target.classList &&
                !(e.target.classList.value.indexOf('menu-list') > -1)
              );
            }}
            styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
            noOptionsMessage={() => {
              return loading ? 'Loading...' : 'No options';
            }}
            isMulti
          />
        </div>
        <div className="mt10">
          {' '}
          <ButtonGroup>
            <Button
              onClick={() => {
                togglePopoverActive();
                setUpdatedValue(value);
              }}
            >
              Cancel
            </Button>
            <Button
              primary
              onClick={() => {
                togglePopoverActive();
                updateSelectedField(updatedValue);
              }}
            >
              Save
            </Button>
          </ButtonGroup>
        </div>
      </CustomField>
    );
  };

  return !popoverActive ? (
    <CField>
      <Wrap className={`${editable ? 'editable-cell' : 'cell'}`}>
        <div className="ellipsis" title={displayVal}>
          {displayVal || <DisabledTag>NA</DisabledTag>}
        </div>
        {editable && <div className="edit-actions">{activator}</div>}
      </Wrap>
    </CField>
  ) : (
    <CField>
      <Wrap className="editable-cell">
        <div className="ellipsis" title={displayVal}>
          {displayVal || <DisabledTag>NA</DisabledTag>}
        </div>
        <Popover
          activator={activator}
          active={popoverActive}
          onClose={() => {
            // togglePopoverActive()
          }}
        >
          {getTag()}
        </Popover>
      </Wrap>
    </CField>
  );
}

export default MultiSelectTextCell;
